import React from 'react';
import { Plug, X } from 'lucide-preact';

import Button from '@/client/components/ui/Button';

/*----------------------------------
- TYPES
----------------------------------*/

type ConnectAccountModalProps = {
    close: (value: boolean) => void;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

export function Modal({ close }: ConnectAccountModalProps) {
    const [clicked, setClicked] = React.useState(false);

    return (
        <div className="relative max-w-md rounded-lg bg-white p-6 text-center shadow-xl">
            <button
                type="button"
                onClick={() => close(false)}
                className="absolute right-4 top-4 rounded-full p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
            >
                <X className="h-4 w-4" />
            </button>
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600">
                <Plug className="h-6 w-6" />
            </div>
            <h3 className="text-lg font-semibold text-slate-900">Connect your Gmail account to start automating your emails.</h3>
            <p className="mt-3 text-sm leading-6 text-slate-600">
                We will redirect you to Unipile, our partner for securely connecting your Gmail account.
            </p>
            <p className="mt-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
                Tip: make sure you check the select all so your Gmail is integrated.
            </p>
            <div className="mt-5 grid gap-2">
                <a
                    href="/prospect/setup/gmail"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => setClicked(true)}
                    className="inline-flex items-center justify-center rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white"
                >
                    {clicked ? 'Retry' : 'Connect'}
                </a>
                {clicked ? (
                    <Button type="button" onClick={() => close(false)}>
                        Done
                    </Button>
                ) : null}
            </div>
        </div>
    );
}
